import { ComponentProps } from 'react'

import {
  MobileOverview,
  RoomThumbnail,
  type TRecentViewedRoom,
} from '@/entities/room'
import { cn } from '@/shared/lib'

export type Props = ComponentProps<'a'> & {
  room: Pick<
    TRecentViewedRoom,
    | 'roomName'
    | 'province'
    | 'town'
    | 'propertyType'
    | 'roomCnt'
    | 'bathroomCnt'
    | 'cookroomCnt'
    | 'sittingroomCnt'
    | 'usingFee'
    | 'mgmtFee'
    | 'picMain'
  >
}

export const MobileRecentRoomItem = ({
  room,
  className,
  ...restProps
}: Props) => {
  return (
    <a
      className={cn('flex w-full flex-row items-center gap-4 py-4', className)}
      {...restProps}
    >
      <div className="shrink-0">
        <RoomThumbnail
          src={room.picMain}
          alt={room.roomName}
          rounded
          size={84}
          ratio="3:2"
          blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN8VA8AAkkBY8DEq9wAAAAASUVORK5CYII="
        />
      </div>
      <div className="min-w-0 flex-1">
        <MobileOverview
          province={room.province}
          town={room.town}
          propertyType={room.propertyType}
          roomName={room.roomName}
          roomCnt={room.roomCnt}
          bathroomCnt={room.bathroomCnt}
          cookroomCnt={room.cookroomCnt}
          sittingroomCnt={room.sittingroomCnt}
          usingFee={room.usingFee}
          mgmtFee={room.mgmtFee}
        />
      </div>
    </a>
  )
}
